import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  useI18n,
  useMerchant,
  useUser,
  useUserRights,
  usePromiseWithContext,
  useDinstictOrderCount,
  config,
} from "@zkt/eb-utility";

import { XCircleFill, Search, ChevronRight } from "@zkt/icons";
import { Layout, notification } from "@zkt/components";
import { Link } from "react-router-dom";
import { getMenus } from "@/components/navbar/service";
import Menu from "./menu";
import "./index.scss";
import { texts } from "./i18n";
import Notify from "./notify";
import { NotifyConfig } from "./notify/interface";

export default function Navbar(props: {
  collapsed: boolean;
  onCollapsed: (v: boolean) => void;
  width: number;
  logoUrl: string;
  logoWidth: number;
  logoHeight: number;
  setNavbarList: (v: Array<unknown>) => void;
}): JSX.Element {
  const tipAudio = useRef<HTMLAudioElement>();
  const orderAudio = useRef<HTMLAudioElement>();

  const {
    collapsed,
    width,
    onCollapsed,
    logoUrl,
    logoWidth,
    logoHeight,
    setNavbarList,
  } = props;
  const inputEl = useRef<HTMLInputElement>(null);

  const [keyword, setKeyword] = useState("");
  const titleTimerId = useRef(null);
  const times = useRef(0);
  const titleText = useRef("直客通 | 商户直销系统技术服务商");
  const titleNew = useRef("直客通 | 您有新的订单，请及时处理~ ");

  const [orderCount, setOrderCount] = useDinstictOrderCount();

  const { merchant } = useMerchant();
  //   const { auth } = useAuth();

  const i18n = useI18n(texts);

  // title新订单滚动提醒
  const titleRoll = useCallback((count) => {
    if (count) {
      if (
        Object.values(count).every((item) => {
          return item === 0;
        })
      ) {
        document.title = titleText.current;
        clearTimeout(titleTimerId.current);
        return;
      }
    }

    times.current += 1;
    clearTimeout(titleTimerId.current);
    document.title =
      titleNew.current.substring(times.current, titleNew.current.length) +
      titleNew.current.substring(0, times.current);

    let delay = 300;
    if (times.current === titleNew.current.length) {
      delay = 900;
      times.current = 0;
      document.title = titleNew.current;
    }

    titleTimerId.current = setTimeout(titleRoll, delay);
  }, []);

  const play = useCallback(() => {
    // 提示音
    tipAudio.current?.play().catch((err) => {
      // eslint-disable-next-line no-console
      console.error(err instanceof DOMException, err.message);
      notification.info({
        message: "订单提醒",
        description: "您有一个新的订单提醒",
        duration: null,
        key: "global-order-tip",
      });
    });
  }, []);

  const playMessage = useCallback(() => {
    // 弹窗
    notification.info({
      message: "订单提醒",
      description: "您有一个新的订单提醒",
      duration: null,
      key: "global-order-tip",
    });
  }, []);

  const handleEnded = useCallback(() => {
    // 消息播报
    orderAudio.current?.play();
  }, [orderAudio]);

  const { user } = useUser();
  const { userRights } = useUserRights();

  // const { result: socketConfig } = usePromiseWithContext((context) => {
  //   if (context.merchantId && context.userId) {
  //     return getNotifyConfig({
  //       userId: context.userId,
  //     });
  //   }
  //   return null;
  // }, []);
  useEffect(() => {
    if (!merchant?.merchantId || !tipAudio.current || !user?.userId) {
      return undefined;
    }
    const socketConfig: NotifyConfig = {
      wss: `wss://${config.newNotifySocket}/webSocket/${user.userId}`,
      version: "v2",
    };
    const notify = new Notify(socketConfig);
    notify
      .init(
        {
          merchantId: merchant.merchantId,
          userId: user.userId,
        },
        {
          update: ({ count, hasNewOrder }) => {
            setOrderCount(count);
            if (hasNewOrder) {
              if (+merchant?.configs?.ENABLE_EB_ORDER_SOUND_REMINDER) {
                play();
              } else {
                playMessage();
              }

              if (+merchant?.configs?.ENABLE_EB_TAB_SCROLL_REMINDER) {
                titleRoll(count);
              }
            } else {
              document.title = titleText.current;
              clearTimeout(titleTimerId.current);
            }
          },
          error: (e) => {
            notification.error({
              message: e.message,
            });
          },
        }
      )
      .start();
    return () => notify.stop();
  }, [
    merchant?.merchantId,
    setOrderCount,
    tipAudio,
    play,
    // socketConfig,
    merchant,
    user,
    titleRoll,
    playMessage,
  ]);

  const { result: menus } = usePromiseWithContext(
    (auth) => {
      if (user && userRights && auth.merchantId === merchant?.merchantId) {
        const getMenusList = getMenus(merchant, user, userRights, auth);

        return getMenusList;
      }
      return Promise.resolve(null) as ReturnType<typeof getMenus>;
    },
    [user?.userId, merchant, userRights]
  );
  // 添加pageAnalyse用于统计当前系统菜单新老页面占比
  useEffect(() => {
    function innerPageAnalyse(
      items: Array<unknown>,
      map: Map<string, Array<unknown>>
    ) {
      if (!Array.isArray(items)) return;
      items.forEach((m) => {
        if (m.link) {
          let type = "eb";
          if (m.link.includes("#")) {
            if (m.link.includes("iframe")) {
              type = "hotel";
            } else {
              type = "ebooking";
            }
          }
          const total = map.get(type) || [];
          total.push(m);
          map.set(type, total);
        }
        innerPageAnalyse(m.children, map);
      });
    }
    globalThis.pageAnalyse = function pageAnalyse(detail: boolean) {
      const map = new Map();
      innerPageAnalyse(menus, map);
      map.forEach((value, key) => {
        console.log(key, value.length);
        if (detail) {
          value.forEach((x) => {
            console.log(`${x.name}:${window.location.origin}${x.link}`);
          });
        }
      });
    };
    return () => {
      delete globalThis.pageAnalyse;
    };
  }, [menus]);
  useEffect(() => {
    setNavbarList(menus);
  }, [menus, setNavbarList]);
  // 点击搜索图标
  const handleSearchClick = useCallback(() => {
    onCollapsed(false);
    setTimeout(() => inputEl.current.focus());
  }, [onCollapsed]);
  return (
    <Layout.Sider
      width={width}
      collapsible
      collapsed={collapsed}
      className="main-index-navbar"
      trigger={null}
    >
      <Link to="/" className="logo text-center">
        <img
          src={logoUrl}
          alt="logo"
          style={{
            maxWidth: logoWidth,
            maxHeight: logoHeight,
          }}
        />
      </Link>
      <div className="search-box-container">
        <div className="search-box">
          <Search onClick={handleSearchClick} className="icon search" />
          <input
            ref={inputEl}
            value={keyword}
            onInput={(e) => setKeyword(e.currentTarget.value)}
            placeholder={i18n.placeholder}
          />
          <XCircleFill
            onClick={() => setKeyword("")}
            className={`icon clear  ${
              !!keyword && !collapsed ? "" : "d-none"
            } `}
          />
        </div>
      </div>
      <div className={`menu-container ${keyword && "keyword"}`}>
        {menus && (
          <Menu
            items={menus}
            inlineCollapsed={collapsed}
            keyword={keyword}
            messageCount={orderCount}
            onCollapsed={onCollapsed}
            onClearKeyword={() => setKeyword("")}
          />
        )}
        <footer className={collapsed ? "d-none" : "d-block"}>
          ©️ zhiketong copyright
        </footer>
      </div>
      <button
        type="button"
        onClick={() => onCollapsed(!collapsed)}
        className={`expander ${collapsed ? "collapsed" : ""}`}
      >
        {collapsed ? "展开" : "收起"}
        <ChevronRight />
      </button>
      <audio
        ref={tipAudio}
        onEnded={handleEnded}
        src="//static.zhiketong.com/static/notification.wav"
      >
        <track kind="captions" />
      </audio>
      <audio ref={orderAudio} src="//static.zhiketong.com/static/order.wav">
        <track kind="captions" />
      </audio>
    </Layout.Sider>
  );
}
